import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'EarlyAccessCreateUserInput' })(() => ({
  input: {
    fontSize: 'var(--ebl-font-size-body2)',
  },
  fieldContainer: {
    width: '100%',
  },
  option: {
    fontSize: 'var(--ebl-font-size-body2)',
  },
}));
